// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wt-truth-summary .panel-heading {
  padding: 0;
}

.wt-truth-summary-toggle.btn.btn-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 15px;
  color: inherit;
  font-weight: 700;
  text-align: left;
  text-decoration: none;
}

.wt-truth-summary-toggle.btn.btn-link:hover,
.wt-truth-summary-toggle.btn.btn-link:focus {
  color: inherit;
  text-decoration: none;
}

.wt-entry-labels {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.wt-entry-verdict-counts {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.wt-entry-verdict-counts-label {
  color: var(--wt-text-muted);
  font-size: 12px;
  font-weight: 600;
}

.wt-entry-options-container.wt-entry-action-bar {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 15px;
  max-width: 100%;
  overflow-x: auto;
  padding-bottom: 3px;
  scrollbar-width: thin;
}

.wt-entry-action-bar > .entry-options {
  float: none !important;
  flex: 0 0 auto;
}

.wt-entry-action-bar > .entry-options > a {
  margin-right: 0;
}

.wt-entry-section-heading {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 22px 0 14px;
  padding: 0 0 9px;
  border-bottom: 1px solid var(--wt-border);
  color: var(--wt-text);
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
}

.nav.nav-tabs.wt-tabs.wt-entry-tabs {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  align-items: stretch;
  gap: 3px;
  margin: 22px 0 14px;
  padding: 4px;
  border: 1px solid var(--wt-border);
  border-radius: 5px;
  background: var(--wt-surface-muted);
  scrollbar-width: thin;
}

.nav.nav-tabs.wt-tabs.wt-entry-tabs::before,
.nav.nav-tabs.wt-tabs.wt-entry-tabs::after {
  display: none;
}

.nav.nav-tabs.wt-tabs.wt-entry-tabs > li {
  float: none;
  flex: 0 0 auto;
}

.nav.nav-tabs.wt-tabs.wt-entry-tabs > li > a,
.nav.nav-tabs.wt-tabs.wt-entry-tabs > li.active > a {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  margin: 0;
  padding: 8px 11px;
  border: 0;
  border-bottom: 3px solid transparent;
  color: var(--wt-text-muted);
  background: transparent;
  white-space: nowrap;
}

.nav.nav-tabs.wt-tabs.wt-entry-tabs > li.active > a,
.nav.nav-tabs.wt-tabs.wt-entry-tabs > li.active > a:hover,
.nav.nav-tabs.wt-tabs.wt-entry-tabs > li.active > a:focus {
  border-bottom-color: #d26911;
  color: var(--wt-text);
  background: var(--wt-surface);
}

@media (max-width: 767px) {
  .nav.nav-tabs.wt-tabs.wt-entry-tabs {
    margin-right: -15px;
    margin-left: -15px;
    padding-right: 15px;
    padding-left: 15px;
    border-right: 0;
    border-left: 0;
    border-radius: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/styles/entry.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,oCAAoC;EACpC,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;EAGE,4BAA4B;EAC5B,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;AACF","sourcesContent":[".wt-truth-summary .panel-heading {\n  padding: 0;\n}\n\n.wt-truth-summary-toggle.btn.btn-link {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 10px 15px;\n  color: inherit;\n  font-weight: 700;\n  text-align: left;\n  text-decoration: none;\n}\n\n.wt-truth-summary-toggle.btn.btn-link:hover,\n.wt-truth-summary-toggle.btn.btn-link:focus {\n  color: inherit;\n  text-decoration: none;\n}\n\n.wt-entry-labels {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.wt-entry-verdict-counts {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.wt-entry-verdict-counts-label {\n  color: var(--wt-text-muted);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.wt-entry-options-container.wt-entry-action-bar {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n  gap: 15px;\n  max-width: 100%;\n  overflow-x: auto;\n  padding-bottom: 3px;\n  scrollbar-width: thin;\n}\n\n.wt-entry-action-bar > .entry-options {\n  float: none !important;\n  flex: 0 0 auto;\n}\n\n.wt-entry-action-bar > .entry-options > a {\n  margin-right: 0;\n}\n\n.wt-entry-section-heading {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin: 22px 0 14px;\n  padding: 0 0 9px;\n  border-bottom: 1px solid var(--wt-border);\n  color: var(--wt-text);\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.nav.nav-tabs.wt-tabs.wt-entry-tabs {\n  display: flex;\n  overflow-x: auto;\n  overflow-y: hidden;\n  align-items: stretch;\n  gap: 3px;\n  margin: 22px 0 14px;\n  padding: 4px;\n  border: 1px solid var(--wt-border);\n  border-radius: 5px;\n  background: var(--wt-surface-muted);\n  scrollbar-width: thin;\n}\n\n.nav.nav-tabs.wt-tabs.wt-entry-tabs::before,\n.nav.nav-tabs.wt-tabs.wt-entry-tabs::after {\n  display: none;\n}\n\n.nav.nav-tabs.wt-tabs.wt-entry-tabs > li {\n  float: none;\n  flex: 0 0 auto;\n}\n\n.nav.nav-tabs.wt-tabs.wt-entry-tabs > li > a,\n.nav.nav-tabs.wt-tabs.wt-entry-tabs > li.active > a {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 40px;\n  margin: 0;\n  padding: 8px 11px;\n  border: 0;\n  border-bottom: 3px solid transparent;\n  color: var(--wt-text-muted);\n  background: transparent;\n  white-space: nowrap;\n}\n\n.nav.nav-tabs.wt-tabs.wt-entry-tabs > li.active > a,\n.nav.nav-tabs.wt-tabs.wt-entry-tabs > li.active > a:hover,\n.nav.nav-tabs.wt-tabs.wt-entry-tabs > li.active > a:focus {\n  border-bottom-color: #d26911;\n  color: var(--wt-text);\n  background: var(--wt-surface);\n}\n\n@media (max-width: 767px) {\n  .nav.nav-tabs.wt-tabs.wt-entry-tabs {\n    margin-right: -15px;\n    margin-left: -15px;\n    padding-right: 15px;\n    padding-left: 15px;\n    border-right: 0;\n    border-left: 0;\n    border-radius: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
